import { proxy } from "valtio";

export default proxy({
    hoveredType: null,
    highlight: {},
})